var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNachkennzeichnen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "20px",
    viewBox: "0 0 40 20",
    enableBackground: "new 0 0 40 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 40,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M31,11.733c0.967,0,1.75-0.784,1.75-1.75c0-0.967-0.783-1.75-1.75-1.75 c-0.966,0-1.75,0.783-1.75,1.75C29.25,10.949,30.034,11.733,31,11.733"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.489,
    strokeLinecap: "round",
    d: "M34.476,16.191 c2.204-1.146,3.716-3.495,3.716-6.208c0-2.687-1.482-5.017-3.65-6.174"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.489,
    strokeLinecap: "round",
    d: "M32.53,13.694 c1.518-0.518,2.612-1.983,2.612-3.711c0-1.722-1.088-3.183-2.598-3.705"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.489,
    strokeLinecap: "round",
    d: "M27.524,16.191 c-2.204-1.146-3.716-3.495-3.716-6.208c0-2.687,1.482-5.017,3.65-6.174"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.489,
    strokeLinecap: "round",
    d: "M29.47,13.694 c-1.518-0.518-2.612-1.983-2.612-3.711c0-1.722,1.088-3.183,2.598-3.705"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M9.25,5.306C9.084,4.832,8.822,4.412,8.466,4.045C8.11,3.678,7.652,3.386,7.093,3.169 C6.534,2.952,5.861,2.843,5.076,2.843c-0.346,0-0.679,0.027-0.999,0.081C3.758,2.977,3.468,3.042,3.208,3.119 c-0.259,0.076-0.482,0.16-0.669,0.25C2.353,3.459,2.226,3.537,2.16,3.604c-0.067,0.067-0.11,0.154-0.13,0.26 C2.01,3.971,2,4.141,2,4.375c0,0.227,0.008,0.414,0.025,0.56C2.042,5.082,2.063,5.196,2.09,5.276 c0.026,0.08,0.059,0.135,0.099,0.165c0.04,0.03,0.083,0.045,0.13,0.045c0.066,0,0.161-0.033,0.284-0.1 c0.123-0.067,0.278-0.14,0.464-0.22s0.409-0.154,0.668-0.221c0.259-0.066,0.558-0.1,0.897-0.1c0.372,0,0.696,0.052,0.972,0.155 C5.88,5.104,6.109,5.252,6.292,5.445c0.183,0.193,0.319,0.423,0.409,0.689c0.09,0.267,0.135,0.56,0.135,0.88 c0,0.287-0.039,0.556-0.115,0.81C6.644,8.077,6.523,8.297,6.357,8.483C6.19,8.67,5.979,8.82,5.723,8.933 c-0.256,0.113-0.561,0.17-0.913,0.17H4.67c-0.146,0-0.273,0.015-0.379,0.045c-0.107,0.03-0.195,0.085-0.265,0.165 C3.956,9.393,3.908,9.5,3.882,9.634c-0.027,0.133-0.037,0.307-0.03,0.521l0.09,2.364c0.006,0.074,0.03,0.135,0.07,0.181 c0.04,0.047,0.103,0.084,0.19,0.11s0.206,0.046,0.356,0.056s0.335,0.015,0.556,0.015c0.347,0,0.613-0.03,0.796-0.09 c0.184-0.06,0.279-0.15,0.286-0.271l0.08-1.949c0.479-0.054,0.917-0.177,1.313-0.371c0.395-0.193,0.735-0.45,1.018-0.77 c0.282-0.321,0.502-0.701,0.658-1.141C9.422,7.848,9.5,7.354,9.5,6.807C9.5,6.28,9.417,5.78,9.25,5.306"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M6.478,14.992c-0.044-0.19-0.12-0.343-0.23-0.46s-0.256-0.2-0.439-0.25 s-0.407-0.075-0.673-0.075c-0.28,0-0.51,0.025-0.689,0.075c-0.18,0.05-0.325,0.133-0.434,0.25c-0.11,0.117-0.186,0.27-0.23,0.46 c-0.043,0.189-0.065,0.425-0.065,0.705c0,0.272,0.022,0.503,0.065,0.689c0.044,0.188,0.12,0.336,0.23,0.45 c0.109,0.113,0.254,0.194,0.434,0.245c0.179,0.05,0.409,0.075,0.689,0.075c0.266,0,0.49-0.025,0.673-0.075 c0.183-0.051,0.329-0.132,0.439-0.245c0.11-0.114,0.186-0.263,0.23-0.45c0.043-0.187,0.065-0.417,0.065-0.689 C6.543,15.417,6.521,15.182,6.478,14.992"
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    points: "17,7 17,9 12,9 12,11 17,11 17,13 21.017,10  "
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNachkennzeichnen);
export default __webpack_public_path__ + "static/media/nachkennzeichnen.9d6daabe86f8805ffa7c91b73c9f938d.svg";
export { ForwardRef as ReactComponent };